import { render } from "./3dPolygons.vue?vue&type=template&id=5fe3246f"
import script from "./3dPolygons.vue?vue&type=script&lang=js"
export * from "./3dPolygons.vue?vue&type=script&lang=js"
script.render = render

export default script